import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactTable from "../../AppComponent/Table";
import _ from "lodash";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import {
    GetDenaveBulkUploadNewDataRequest,
    GetSheetBulkUploadDataSucess,
    SheetBulkUploadSucess,
    setSelectedUploadTab,
} from "../../../Redux/Slice";
import { FaDownload } from "react-icons/fa";
import EmployeeBulkuploadPopup from "./EmployeeBulkuploadPopup";
import { useNavigate } from "react-router-dom";
import yesIcon from "../../../Assets/yes.png";
import errorIcon from "../../../Assets/error.png";
import fileDownloadIcon from "../../../Assets/fileDownload.png";
import DenaveNewBulkuploadPopup from "./DenaveNewBulkuploadPopup";

const EMPLOYEE_TYPE_LABELS = {
    "0": "Permanent",
    "1": "Contractual",
    "2": "Consultant",
    "3": "Freelancer",
    "4": "Intern",
    "5": "Apprentice",
};

const EMPLOYEE_CATEGORY_LABELS = {
    "0": "FOS",
    "1": "Non FOS",
    "2": "Non FOS - Tele",
    "3": "Apprentice",
};

const STATUS_BADGES = {
    "0": { label: "Link Sent", background: "#e7f1ff", color: "#0d6efd" },
    "1": { label: "Link Expired", background: "#fde8e8", color: "#dc3545" },
    "2": { label: "Completed", background: "#e6f4ea", color: "#198754" },
};

// status code from backend, with fallback for invites created before `status` existed
const getStatusBadge = (item) => {
    const code = item?.status;
    if (code !== null && code !== undefined && STATUS_BADGES[String(code)]) {
        return STATUS_BADGES[String(code)];
    }
    if (item?.is_employee_signed) return STATUS_BADGES["2"];
    if (item?.link_expired) return STATUS_BADGES["1"];
    if (item?.is_invite_link_sent) return STATUS_BADGES["0"];
    return null;
};

// ISO datetime -> YYYY-MM-DD h:mm A (same style as Created Date)
const formatDateTime = (value) => {
    if (!value) return "-";
    const d = new Date(value);
    if (isNaN(d.getTime())) return "-";
    const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
    const hours = d.getHours();
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}  ${hours % 12 || 12}:${pad(d.getMinutes())} ${hours >= 12 ? "PM" : "AM"}`;
};

const DenaveNewBulkUpload = () => {
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive,
    );
    const dispatch = useDispatch();
    const [sno, setsno] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);

    const [dtpageindex, setdtPageindex] = useState(1);
    const [dtpagesize, setdtPagesize] = useState(10);
    const [search, setsearch] = useState("");
    const [DeleteID, setDeleteId] = useState();
    const [DeletePopup, setDeletePopup] = useState(false);
    const [pageSize, setPageSize] = useState(20);
    const navigate = useNavigate();

    const selectedTab = useSelector(
        (state) => state.SideBarFiles.selectedUploadTab
    );

    const handleTabChange = (tabName) => {
        dispatch(setSelectedUploadTab(tabName));
    };

    const { denaveBulkUploadNewData: employeeBulkUploaddata, totalCount } = useSelector(
        (state) => state.denaveBulkUploadNewGetData,
    );

    console.log(employeeBulkUploaddata, "kdlksakldalkdlkalk");
    const [bulkUploadPopup, setBulkUploadPopup] = useState(false);

    const pagesize = (arg) => {
        setdtPagesize(arg);
    };
    const pageindex = (arg) => {
        //  console.log(arg, "args");
        setdtPageindex(arg);
    };

    const debouncedSearch = useMemo(
        () =>
            _.debounce((e) => {
                // console.log("Searching for:", e);

                setsearch(e);
            }, 500),
        [],
    );
    function tochange(e) {
        setdtPageindex(1);
        // setsearch(e);
        debouncedSearch(e);
    }

    const handleNext = (next) => {
        setdtPageindex(next + 1);
    };

    const GotoEnteredPage = (gotopage) => {
        setdtPageindex(gotopage);
    };

    const handleDownload = (url) => {
        if (!url) return;

        window.open(url, "_blank");
    };

    // useEffect(() => {
    //     // dispatch(setSelectedUploadTab("Self onboarding"));
    //     const payload = {
    //         page_size: 20,
    //         page: 1,
    //         search: "",
    //     };
    //     dispatch(GetDenaveBulkUploadNewDataRequest(payload));
    // }, []);
    useEffect(() => {
        const payload = {
            page_size: 20,
            page: dtpageindex,
            search: search,
        };
        dispatch(GetDenaveBulkUploadNewDataRequest(payload));
    }, [dtpageindex, search]);
    useEffect(() => {
        const interval = setInterval(() => {
            dispatch(
                GetDenaveBulkUploadNewDataRequest({
                    page_size: 20,
                    page: dtpageindex,
                    search: search,
                }),
            );
        }, 10000);

        return () => clearInterval(interval);
    }, [dispatch, dtpageindex, search]);
    const handlePrevious = (previous) => {
        if (previous != 0) {
            setdtPageindex(previous);
        }
    };

    const columns = useMemo(
        () => [
            {
                Header: "S.NO",
                accessor: "",
                Cell: (row) => {
                    console.log(row.row);
                    console.log(sno);
                    return <p>{Number(sno + row.row.index + 1)}</p>;
                },
            },

            {
                Header: "Employee Name",
                accessor: "employee_name",
                Cell: (row) => {
                    return (
                        <>
                            <span className="wrap-cell" style={{ minWidth: "150px", maxWidth: "200px" }}>
                                {row.row.original?.employee_name}
                            </span>
                        </>
                    );
                },
            },

            {
                Header: "Phone Number",
                accessor: "phone_number",
                Cell: (row) => {
                    return (
                        <>
                            <span>{row.row.original?.phone_number}</span>
                        </>
                    );
                },
            },
            {
                Header: "Email",
                accessor: "email",
                Cell: (row) => {
                    return (
                        <>
                            <span>{row.row.original?.email}</span>
                        </>
                    );
                },
            },
            {
                Header: "CC Mail",
                accessor: "cc_email",
                Cell: (row) => {
                    const cc = row.row.original?.cc_email ?? row.row.original?.cc_mail;
                    const text = Array.isArray(cc) ? cc.join(", ") : cc;
                    return (
                        <span className="wrap-cell" style={{ maxWidth: "240px" }}>
                            {text || "-"}
                        </span>
                    );
                },
            },

            {
                Header: "Aadhar Number",
                accessor: "aadhar_number",
                Cell: (row) => {
                    return (
                        <>
                            <span>{row.row.original?.aadhar_number}</span>
                        </>
                    );
                },
            },

            {
                Header: "Designation",
                accessor: "designation",
                Cell: (row) => {
                    return (
                        <>
                            <span className="wrap-cell" style={{ minWidth: "140px", maxWidth: "180px" }}>
                                {row.row.original?.designation_id?.role}
                            </span>
                        </>
                    );
                },
            },

            {
                Header: "Client",
                accessor: "client_id",
                Cell: (row) => {
                    return (
                        <>
                            <span className="wrap-cell" style={{ minWidth: "220px", maxWidth: "280px" }}>
                                {row.row.original?.client_id?.client_name}
                            </span>
                        </>
                    );
                },
            },
            {
                Header: "Project Code",
                accessor: "project_code",
                Cell: (row) => {
                    return (
                        <>
                            <span>{row.row.original?.project_code}</span>
                        </>
                    );
                },
            },
            {
                Header: "Created Date",
                accessor: "",
                Cell: (row) => {
                    const dateString = row.row.original.created_at;
                    const dateObject = new Date(dateString);
                    const hours = dateObject.getHours();
                    const minutes = dateObject.getMinutes();
                    const seconds = dateObject.getSeconds();
                    const amOrPm = hours >= 12 ? "PM" : "AM";
                    const twelveHourFormat = hours % 12 || 12;
                    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

                    const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
                    return (
                        <>
                            <span style={{ textWrap: "nowrap" }}>
                                {`${row.row.original.created_at.slice(0, 10) +
                                    "  " +
                                    formattedTime
                                    }`}
                            </span>
                        </>
                    );
                },
            },

            // {
            //     Header: "Invite Sent",
            //     accessor: "is_invite_link_sent",
            //     Cell: (row) => {
            //         return (
            //             <>
            //                 <span>{row.row.original?.is_invite_link_sent ? "Yes" : "No"}</span>
            //             </>
            //         );
            //     },
            // },
            {
                Header: "Link Expired",
                accessor: "link_expired",
                Cell: (row) => {
                    return (
                        <>
                            <span>{row.row.original?.link_expired ? "Expired" : "Not Expired"}</span>
                        </>
                    );
                },
            },
            {
                Header: "Status",
                accessor: "status",
                Cell: (row) => {
                    const badge = getStatusBadge(row.row.original);
                    if (!badge) return <span>-</span>;
                    return (
                        <span
                            style={{
                                display: "inline-block",
                                padding: "3px 10px",
                                borderRadius: "12px",
                                fontSize: "12px",
                                fontWeight: 600,
                                whiteSpace: "nowrap",
                                background: badge.background,
                                color: badge.color,
                            }}
                        >
                            {badge.label}
                        </span>
                    );
                },
            },
            {
                Header: "Signed",
                accessor: "is_employee_signed",
                Cell: (row) => {
                    return <span>{row.row.original?.is_employee_signed ? "Yes" : "No"}</span>;
                },
            },
            {
                Header: "Signed At",
                accessor: "employee_signed_at",
                Cell: (row) => {
                    return (
                        <span style={{ textWrap: "nowrap" }}>
                            {formatDateTime(row.row.original?.employee_signed_at)}
                        </span>
                    );
                },
            },
            // {
            //     Header: "Employee Type",
            //     accessor: "employee_type",
            //     Cell: (row) => {
            //         const code = row.row.original?.employee_type;
            //         return <span>{EMPLOYEE_TYPE_LABELS[String(code)] || "-"}</span>;
            //     },
            // },
            // {
            //     Header: "Employee Category",
            //     accessor: "employee_category",
            //     Cell: (row) => {
            //         const code = row.row.original?.employee_category;
            //         return <span>{EMPLOYEE_CATEGORY_LABELS[String(code)] || "-"}</span>;
            //     },
            // },

            // {
            //     Header: "Offer Letter",
            //     accessor: "offer_letter",
            //     Cell: (row) => {
            //         const url = row.row.original?.offer_letter;

            //         return url ? (
            //             <span
            //                 onClick={() => handleDownload(url)}
            //                 title="Download Uploaded Sheet"
            //                 style={{
            //                     display: "flex",
            //                     alignItems: "center",
            //                     gap: "5px",
            //                     cursor: "pointer",
            //                     border: "1px solid green",
            //                     backgroundColor: "green",
            //                     padding: "3px 7px",
            //                     color: "white",
            //                     borderRadius: "5px",
            //                 }}
            //             >
            //                 <img
            //                     src={fileDownloadIcon}
            //                     alt="Download"
            //                     style={{ width: "30px", height: "30px" }}
            //                 />{" "}
            //                 <span>Download</span>
            //             </span>
            //         ) : null;
            //     },
            // },
        ],

        [employeeBulkUploaddata],
    );

    return (
        <>
            <div className={stateDisplay ? "outterContent" : "inner-Content"}>
                <div
                    className="Header-Details ClientBranch"
                    style={{
                        padding: "14px 28px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "20px !important",
                    }}
                >
                    <div
                        // className="InnerUsers col-md-6"
                        class="col-sm-7 auto"
                        style={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <div style={{ display: "flex", gap: "25px", borderBottom: "1px solid #dee2e6", width: "100%" }}>
                            <span
                                className="user-name mb-0"
                                style={{
                                    cursor: "pointer",
                                    fontSize: "18px",
                                    fontWeight: selectedTab === "Denave Bulkupload" ? "600" : "400",
                                    color: selectedTab === "Denave Bulkupload" ? "#f26639" : "#6b7280",
                                    borderBottom: selectedTab === "Denave Bulkupload" ? "3px solid #f26639" : "3px solid transparent",
                                    paddingBottom: "8px",
                                    transition: "all 0.3s ease"
                                }}
                                onClick={() => handleTabChange("Denave Bulkupload")}
                            >
                                Denave Bulkupload
                            </span>
                            <span
                                className="user-name mb-0"
                                style={{
                                    cursor: "pointer",
                                    fontSize: "18px",
                                    fontWeight: selectedTab === "Self onboarding" ? "600" : "400",
                                    color: selectedTab === "Self onboarding" ? "#f26639" : "#6b7280",
                                    borderBottom: selectedTab === "Self onboarding" ? "3px solid #f26639" : "3px solid transparent",
                                    paddingBottom: "8px",
                                    transition: "all 0.3s ease"
                                }}
                                onClick={() => handleTabChange("Self onboarding")}
                            >
                                Self onboarding
                            </span>
                        </div>
                    </div>
                    <div
                        className="Add-User col-sm-5"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            justifyContent: "flex-end",
                        }}
                    >
                        {/* <button
                            onClick={(e) => {
                                navigate("/denavebulkupload/new");
                            }}
                            className="ButtonCSS"
                            style={{ marginBottom: "10px" }}
                        >
                            New Bulkupload
                        </button>*/}
                        <button
                            onClick={(e) => {
                                navigate("/denavebulkupload/selfonboard-preview");
                            }}
                            className="ButtonCSS"
                            style={{ marginBottom: "10px" }}
                        >
                            Bulkupload Status
                        </button>
                        <button
                            onClick={(e) => {
                                setBulkUploadPopup(true);
                            }}
                            className="ButtonCSS"
                            style={{ marginBottom: "10px" }}
                        >
                            Bulk Upload
                        </button>
                    </div>
                </div>
                <div
                    className="denave-self-onboard-table"
                    style={{
                        padding: " 0px 40px",
                        marginTop: "-13px",
                        marginBottom: "20px",
                    }}
                >
                    {/* wider table so the extra columns scroll horizontally (table-responsive wrapper) */}
                    <style>{`
                        .denave-self-onboard-table .table-responsive { overflow-x: auto; container-type: inline-size; }
                        .denave-self-onboard-table .INNERTABLE { width: max-content; min-width: 100%; }
                        .denave-self-onboard-table .Dusbinbacktabls { position: sticky; left: 0; width: 100cqw; }
                        .denave-self-onboard-table .table-responsive > .row { position: sticky; left: 0; width: 100cqw !important; }
                        .denave-self-onboard-table .TableDesgin { min-width: 1900px; }
                        .denave-self-onboard-table .TableDesgin th {
                            width: auto !important;
                            white-space: nowrap;
                            vertical-align: middle;
                            padding: 12px 14px !important;
                        }
                        .denave-self-onboard-table .TableDesgin td {
                            white-space: nowrap;
                            vertical-align: middle;
                            padding: 12px 14px !important;
                        }
                        .denave-self-onboard-table .TableDesgin td p { margin: 0; }
                        .denave-self-onboard-table .wrap-cell {
                            display: inline-block;
                            white-space: normal;
                            word-break: break-word;
                        }
                    `}</style>
                    <ReactTable
                        data={employeeBulkUploaddata ? employeeBulkUploaddata : []}
                        columns={columns}
                        filterRowAction={
                            <button
                                onClick={() => {
                                    navigate("/reportsheet", {
                                        state: {
                                            openCreate: true,
                                            reportType: "denave_self_onboarding_report",
                                        },
                                    });
                                }}
                                className="ButtonCSS"
                                style={{
                                    background: "#F15D39",
                                    color: "#fff",
                                    opacity: 1,
                                    padding: "10px 28px",
                                    borderRadius: "6px",
                                    border: "none",
                                    fontWeight: 600,
                                }}
                            >
                                Download
                            </button>
                        }
                        // totalItems={state.ReportSheetData.Total_Count}
                        currentPage={currentPage}
                        onChange={tochange}
                        setCurrentPage={setCurrentPage}
                        pagesize={pagesize}
                        dtpagesize={pageSize}
                        dtpageindex={dtpageindex}
                        pageindex={pageindex}
                        // datacount={state.ReportSheetData.Total_Count}
                        // datacount={state.ReportSheetData?.Total_Count}
                        totalItems={totalCount}
                        datacount={totalCount}
                        MakeCreate={false}
                        Filter={true}
                        NoFilter={true}
                        search_key={true}
                        searchVal={search}
                        onPrevious={handlePrevious}
                        onNextpage={handleNext}
                        GotoEnteredPage={GotoEnteredPage}
                        // value={StatusVal}
                        // options={options}
                        // count={count}
                        // ClearState={ClearState}
                        placeHold={"All"}
                        setsno={setsno}
                        sno={sno}
                        id={"spe"}
                    />
                </div>
                {bulkUploadPopup && (
                    <DenaveNewBulkuploadPopup setPopup={setBulkUploadPopup} />
                )}
            </div>
        </>
    );
};



export default DenaveNewBulkUpload